import React, { useState, useEffect } from "react";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";

import "./date-range-picker.scss";
import { SizeType } from "antd/lib/config-provider/SizeContext";

const { RangePicker } = DatePicker;

interface IDateRangePickerProps {
  className?: string;
  inputReadOnly?: boolean;
  showTime?: boolean;
  disabled?: boolean;
  allowClear?: boolean;
  format?: string;
  disabledDate?: any;
  size?: SizeType;
  defaultValue?: [Dayjs | null, Dayjs | null];
  onChange: (value: any) => void;
}

export const DateRangePicker = ({
  className = "",
  inputReadOnly = true,
  showTime = false,
  disabled = false,
  allowClear = true,
  size = "middle",
  defaultValue = [null, null],
  format = "DD/MM/YYYY",
  disabledDate = null,
  onChange,
}: IDateRangePickerProps): JSX.Element => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 560);
  const [pickerKey, setPickerKey] = useState(0);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 560);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Reset key when dropdown closes so next open gets fresh defaultPickerValue
  const handleOpenChange = (open: boolean) => {
    if (!open) setPickerKey((k) => k + 1);
  };

  return (
    <RangePicker
      key={pickerKey}
      className={`date-range-picker ${className}`}
      popupClassName={isMobile ? "date-range-picker-mobile" : ""}
      inputReadOnly={inputReadOnly}
      showTime={showTime}
      defaultValue={defaultValue}
      allowClear={allowClear}
      format={format}
      disabled={disabled}
      onChange={onChange}
      disabledDate={disabledDate}
      size={size}
      defaultPickerValue={[dayjs().subtract(1, "month"), dayjs().subtract(1, "month")]}
      onOpenChange={handleOpenChange}
      {...(isMobile ? { getPopupContainer: () => document.body } : {})}
    />
  );
};
